export default "__VITE_ASSET__CfIBUGMs__"